// Libs
import React, { Component } from "react";
import PropTypes from "prop-types";

// DLS Components
import "@collectivehealth/dls-icons/dist/elements/dls-icon-chevron-right";
import "@collectivehealth/dls-icons/dist/elements/dls-icon-people-group";
import "@collectivehealth/dls-icons/dist/elements/dls-icon-documents";
import "@collectivehealth/dls-icons/dist/elements/dls-icon-person-single";
import "@collectivehealth/dls-icons/dist/elements/dls-icon-claims";
import "@collectivehealth/dls-icons/dist/elements/dls-icon-log-out";

// Constants
export const DATA_HOOK = "MenuIcon";

const ICON_PROPS = {
  slot: "icon-label-glyph",
  "data-hook": DATA_HOOK
};

export default class MenuIcon extends Component {
  static propTypes = {
    title: PropTypes.string
  };

  render() {
    const { title } = this.props;

    switch (title) {
      case "Account":
        return <dls-icon-person-single {...ICON_PROPS} />;
      case "Claims":
      case "Analytics":
        return <dls-icon-claims {...ICON_PROPS} />;
      case "Documents":
        return <dls-icon-documents {...ICON_PROPS} />;
      case "People":
        return <dls-icon-people-group {...ICON_PROPS} />;
      case "Logout":
        return <dls-icon-log-out {...ICON_PROPS} />;
      default:
        return null;
    }
  }
}
